"use strict";

exports.__esModule = true;
exports.default = filters;

var types = _interopRequireWildcard(require("./types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable */
function query(query, action) {
  var payload = action.payload;

  switch (action.type) {
    case types.ON_ADD_FILTER_QUERY:
    case types.ON_EDIT_FILTER_QUERY:
      return _extends(_extends({}, query), payload);

    default:
      return query;
  }
}

function queries(queries, action) {
  if (queries === void 0) {
    queries = [];
  }

  var index = action.index;

  switch (action.type) {
    case types.ON_ADD_FILTER_QUERY:
      return [].concat(queries, [query({}, action)]);

    case types.ON_EDIT_FILTER_QUERY:
      return queries.map(function (q, i) {
        if (index !== i) {
          return q;
        }

        return query(q, action);
      });

    case types.ON_REMOVE_FILTER_QUERY:
      return queries.filter(function (item, i) {
        return i !== index;
      });

    default:
      return queries;
  }
}

function search(search, action) {
  if (search === void 0) {
    search = {};
  }

  var payload = action.payload;

  switch (action.type) {
    case types.ON_SET_SEARCH:
      return _extends(_extends({}, search), {}, {
        value: payload
      });

    default:
      return search;
  }
}

function filter(filter, action) {
  if (filter === void 0) {
    filter = {};
  }

  var payload = action.payload;

  switch (action.type) {
    case types.ON_FILTER_IS_OPEN:
    case types.ON_FILTER_IS_CLOSE:
    case types.ON_FILTER_SORT_FIELD_CHANGED:
    case types.ON_FILTER_SORT_ORIENTATION_CHANGED:
      return _extends(_extends({}, filter), payload);

    case types.ON_ADD_FILTER_QUERY:
    case types.ON_EDIT_FILTER_QUERY:
    case types.ON_REMOVE_FILTER_QUERY:
      return _extends(_extends({}, filter), {}, {
        queries: queries(filter.queries, action)
      });

    case types.ON_SET_SEARCH:
      return _extends(_extends({}, filter), {}, {
        search: search(filter.search, action)
      });

    case types.ON_CLEAR:
      return {
        fields: filter.fields
      };

    default:
      return filter;
  }
}

function filters(state, action) {
  if (state === void 0) {
    state = {};
  }

  var name = action.name;

  switch (action.type) {
    case types.ON_FILTER_IS_OPEN:
    case types.ON_FILTER_IS_CLOSE:
    case types.ON_FILTER_SORT_FIELD_CHANGED:
    case types.ON_FILTER_SORT_ORIENTATION_CHANGED:
    case types.ON_ADD_FILTER_QUERY:
    case types.ON_EDIT_FILTER_QUERY:
    case types.ON_REMOVE_FILTER_QUERY:
    case types.ON_SET_SEARCH:
    case types.ON_CLEAR:
      return _extends(_extends({}, state), {}, {
        [name]: filter(state[name], action)
      });

    default:
      return state;
  }
}
/* eslint-enable */


module.exports = exports.default;